import * as Immutable from 'immutable';

import type {ErrorCode} from 'constants/error-codes';
import type {MapOf} from 'immutable';

type ImmutableErrorCode = MapOf<ErrorCode>;

/**
 * The Immutable conversion here to JS is probably just for cases where we are passing in a Meteor Error and not an
 * actual ErrorCode object. This might have only been done in `reset-password`, but it is safer just to leave as is even
 * if it is not doing anything.
 */
export const errorCodesAreEqual = (
    errorCodeA: ErrorCode | ImmutableErrorCode,
    errorCodeB: ErrorCode | ImmutableErrorCode,
) => {
    const a = Immutable.isImmutable(errorCodeA) ? errorCodeA.toJS() : errorCodeA;
    const b = Immutable.isImmutable(errorCodeB) ? errorCodeB.toJS() : errorCodeB;
    return a.errorCode === b.errorCode;
};

export default {
    errorCodesAreEqual,
};
